module.exports = __webpack_public_path__ + "img/hk.5ecd0b14.png";